import api from '@/api'

export default {
	getOrgTree: function (data: recipient.DepartmentOption): Promise<recipient.Department[]> {
		return api
		  .post<{ items: recipient.Department[] }>({
			url: '/CubeLook/Hr/api/getTree',
			data: data,
		  }).then(res => res.items);
	},	

	/**
	 * 부서 코드로 조직도 내 부서 경로를 조회합니다.
	 * @param {object} data
	 *          { comCode: {string}, // 회사 코드
	 *            deptCode: {string} // 부서 코드 }
	 */
	getDeptPath: function (comCode: string, deptCode?: string): Promise<string> {
		return api.post<{ items: recipient.Department[] }>({
			url: '/CubeLook/Hr/api/getTreePath',
			data: {
				comCode,
				deptCode,
			},
		}).then(res => {
			if(res.items.length > 0) {
				return res.items[0].path;
			} else {
				return '';
			}
		})
	},
	
	getCompanies (isWithDisabled: boolean = false): Promise<recipient.companyInfoList> {
		return api.get({
			url: '/Common/Company/api/list?isWithDisabled=' + isWithDisabled,
			params: {
				isWithDisabled: isWithDisabled
			}
		})
    },
    	/**
	 * 회사코드와 부서코드로 부서원을 조회합니다.
	 * @param {object} data
	 * { deptCode: {string}, // 부서 코드
	 *      comCode: {string} // 회사 코드
	 *  }
	 */
	getEmployeeList: function (
		data: recipient.DepartmentOption
	): Promise<recipient.PagedItemList<recipient.OrgPerson>> {
		return api.post({
			url: '/CubeLook/Hr/api/getEmployeelist',
			data: data,
		})
	},
	/**
	 * 검색어로 부서 또는 직원을 조회합니다.
	 * @param {object} recipientSearchOptions 검색옵션
	 */
	searchOrg: function (keyword: string, comCode: string): Promise<any> {
		return api
			.post({
				url: '/CubeLook/Hr/api/search',
				data: { comCode, keyword },
			})
			.then((res: any) => res)
			.catch((err: any) => {
				console.log('searchOrg', 'err', err)
			})
	},
}
